import React from "react";
import {
  Row,
  Col,
  Typography,
  Input,
  Pagination,
  Spin,
  Empty,
  ConfigProvider,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useInstitutionTherapies } from "../../../../hooks/revi/useInstitutionTherapies";
import { TherapyCardInst } from "../../../../components/Admin/InstitutionCmp/TherapiesCmp";
// Reutilizamos el modal existente
import { TherapyDetailModal } from "../../../../components/Admin/SalasCmp";
import "./Page_Institution_Therapies.scss";

const { Title, Text } = Typography;

export function Page_Institution_Therapies() {
  const { t } = useTranslation("institution");

  const {
    therapies,
    pagination,
    loading,
    loadTherapies,
    selectedTherapy,
    isModalOpen,
    modalLoading,
    handleViewDetail,
    closeModal,
  } = useInstitutionTherapies();

  return (
    <ConfigProvider>
      <div className="page-institution-therapies">
        <div style={{ marginBottom: 32 }}>
          <Title level={2} style={{ margin: 0 }}>
            {t("therapies.title")}
          </Title>
          <Text type="secondary">{t("therapies.subtitle")}</Text>

          <div style={{ marginTop: 24, maxWidth: 400 }}>
            <Input
              prefix={<SearchOutlined />}
              placeholder={t("therapies.searchPlaceholder")}
              allowClear
              onPressEnter={(e) => loadTherapies(1, e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: 50 }}>
            <Spin size="large" />
          </div>
        ) : therapies.length === 0 ? (
          <Empty description={t("therapies.empty")} />
        ) : (
          <>
            <Row gutter={[24, 24]}>
              {therapies.map((therapy) => (
                <Col key={therapy._id} xs={24} sm={12} lg={8} xl={6}>
                  <TherapyCardInst
                    therapy={therapy}
                    onClick={handleViewDetail}
                  />
                </Col>
              ))}
            </Row>

            {pagination.totalPages > 1 && (
              <div style={{ marginTop: 32, textAlign: "center" }}>
                <Pagination
                  current={pagination.page}
                  total={pagination.totalDocs}
                  pageSize={12}
                  onChange={(page) => loadTherapies(page)}
                  showSizeChanger={false}
                />
              </div>
            )}
          </>
        )}

        {/* Modal en modo solo lectura (sin onRemoveStep) */}
        <TherapyDetailModal
          isOpen={isModalOpen}
          onClose={closeModal}
          therapy={selectedTherapy}
          loading={modalLoading}
          // No pasamos onRemoveStep ni onViewScene para modo "solo lectura" o los implementamos si quieres
          onViewScene={() => {}}
        />
      </div>
    </ConfigProvider>
  );
}
